import { useEffect } from "react";
import { useSession } from "../../hooks/useSession";
import { useAppointmentResponse } from "../../hooks/useAppointmentResponse";

export const useDatiPersonaliNonRiconosciutoPage = () => {
    const { read, update } = useSession();
    const { handleAppointmentSubmission, isCreaAppuntamentoBusy, fetchErrorMessage, fetchError, setFetchError, setFetchErrorMessage } = useAppointmentResponse();

    useEffect(() => {
        update("utenteRiconosciuto", false);
    }, []);

    const next = async () => {
        if (read("cfErrorInForm")) {
            console.log("blocca");
            setFetchErrorMessage("Nome e cognome non coincidono con il codice fiscale");
            setFetchError(true);
        } else {
            console.log("handleAppointmentSubmission");
            handleAppointmentSubmission();
        }
    };

    return {
        next,
        read,
        isCreaAppuntamentoBusy,
        fetchErrorMessage,
        fetchError,
        setFetchError,
    };
};
